var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaffManage-list"},[_c('GlobalInfoBar',{attrs:{"title":"礼包设置","content":"配置线上回收,顾客到店回收礼包赠品管理"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('From')],1),_c('Table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }